let running = false;
let latestWork: (() => Promise<void>) | null = null;

async function drain(): Promise<void> {
  while (latestWork) {
    const work = latestWork;
    latestWork = null;
    await work();
  }
}

/** Runs one queue snapshot at a time and coalesces pending snapshots to the latest state. */
export function enqueueLatestPromptQueueStateWork(work: () => Promise<void>): void {
  latestWork = work;
  if (running) return;
  running = true;
  void drain().finally(() => {
    running = false;
    if (latestWork) enqueueLatestPromptQueueStateWork(latestWork);
  });
}
